<script lang="ts" setup>
import { useMq } from 'vue3-mq'
import { storeToRefs } from 'pinia'
import { useRoot } from '~/store'

const root = useRoot()
const { xs, sm } = useMq()

const { theme } = storeToRefs(root)

const { openToast } = root

const { locale, t } = useI18n()

const filename = computed(() => {
  const baseFilename = 'cv-lorenzo-rottigni'
  const _locale = locale.value === 'it' ? 'it' : 'en'
  const _theme = theme.value?.code !== 'militar' ? theme.value?.code : ''
  return `${baseFilename}${_theme !== '' ? `-${_theme}` : ''}-${_locale}-min.pdf`
})

const cvRottigniTech = computed(
  () => `https://cv.rottigni.tech${locale.value === 'it' ? '/it/' : '/'}?puppeteer=true&theme=${theme.value?.code}`
)
</script>

<template lang="pug">
section.cv__alpha
  h1 {{ (xs || sm) ? $t('cv.alpha.title-desktop') : $t('cv.alpha.title-mobile')  }}
  figure.cv__alpha__iframe
    iframe(:src="cvRottigniTech")
    figcaption Content transmitted from
      span https://cv.rottigni.tech
</template>

<style lang="sass" scoped>
section.cv__alpha
  @apply w-full h-full flex flex-col items-center justify-center gap-6
  h1
    @apply text-4xl text-primary font-bold text-center text-animated
  figure.cv__alpha__iframe
    @apply w-full lg:w-10/12 h-[50vh] lg:h-[60vh] border-8 border-primary border-double relative
    iframe
      @apply w-full h-full bg-primary
    figcaption
      @apply absolute top-0 left-[50%] translate-x-[-50%] bg-primary py-0.5 px-4 text-xs text-dark-900 font-bold text-center whitespace-nowrap
      clip-path: polygon(0 0, 100% 0, 95% 100%, 5% 100%)
      span
        @apply underline ml-1
</style>
